import { render, staticRenderFns } from "./to-destroy-req.vue?vue&type=template&id=6be6ff10&scoped=true"
import script from "./to-destroy-req.vue?vue&type=script&lang=js"
export * from "./to-destroy-req.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be6ff10",
  null
  
)

export default component.exports